// extracted by mini-css-extract-plugin
export default {"header":"managePeople_header__Lutba","backArrow":"managePeople_backArrow__L2QoN","managePeople":"managePeople_managePeople__Lmb9B"};